export default {
    login_register: 'Entrar/Registrar',
    booking_confirmation_title: 'Confirmação de reserva',
    booking_confirmation_body: 'Obrigado pela sua reserva. Veja os detalhes da confirmação abaixo.',
    insurance_requirements_modal_disclaimer: `Ao fazer esta reserva, confirmo que: não tive condenações ou infrações de trânsito nos últimos 5 anos. Não tive proposta recusada, apólice cancelada ou renovação recusada, nem fui obrigado a pagar prêmio aumentado ou tive condições especiais impostas por qualquer seguradora. Não fui desqualificado para dirigir. Não tenho processos ou investigações policiais em andamento. Não tenho condenações por roubo, fraude ou desonestidade nos últimos 5 anos. Não sofro de deficiência de visão ou audição (não corrigida por óculos ou aparelho auditivo), doença cardíaca, diabetes, convulsões ou qualquer deficiência física ou mental. Não tive acidentes nos últimos 5 anos. Clique em {0} se você não atender a esses requisitos.`,
    insurance_requirements_here: 'aqui',
    insurance_requirements: 'Li e entendi os {0}',
    ir: 'Requisitos de Seguro',
    location: 'Localização',
    pickup_location: 'Local de retirada',
    dropoff_location: 'Local de devolução',
    vehicle: 'Veículo',
    pickup_and_dropoff: 'Retirada e Devolução (horário local)',
    view_voucher: 'Ver voucher',
    identity_verification_body: 'Você precisará verificar sua identidade antes de retirar o veículo',
    identity_verification_title: 'Verificar identidade',
    search_again: 'Pesquisar novamente',
    refrigerated: 'refrigerado',
    aircon_lower: 'ar-condicionado',
    aircon: 'Ar-condicionado',
    refrigeration: 'Refrigerado',
    not_available: 'Drive & Go está disponível apenas para pessoas com documentos de identidade e carteira de motorista dos seguintes países.',
    check_if_included: 'Verifique se seu país está incluído.',
    included_in_booking: 'Incluído nesta reserva',
    cdw_with_excess: 'CDW com franquia',
    theft_protection: 'Proteção contra roubo com franquia',
    risk_reduction: 'Redução de risco',
    free_extras: 'Você tem direito a dois extras gratuitos <br /> nesta reserva.',
    continue: 'Continuar',
    luggage_large_short_label: 'G',
    luggage_medium_short_label: 'M',
    luggage_small_short_label: 'P',
    luggage_large_long_label: 'grande',
    luggage_medium_long_label: 'médio',
    luggage_small_long_label: 'pequeno',
    fuel_unspecified_label: 'não especificado',
    transmission_manual_label: 'Manual',
    transmission_automatic_label: 'Automático',
    make_a_booking: 'Fazer uma reserva',
    pickup_date: 'Data de retirada',
    dropoff_date: 'Data de devolução',
    driver_age: 'Motorista entre 30 - 65',
    enter_driver_age: 'Informe a idade do motorista',
    promo_code: 'Código promocional',
    search: 'Pesquisar',
    dropoff_date_cannot_be_before_pickup_date: 'A data de devolução não pode ser anterior à data de retirada',
    pickup_date_cannot_be_in_the_past: 'A data de retirada não pode estar no passado',
    pickup_time_cannot_be_in_the_past: 'O horário de retirada não pode estar no passado',
    dropoff_time_must_be_later_than_the_pickup_time_if_on_the_same_day: 'O horário de devolução deve ser posterior ao de retirada se for no mesmo dia',
    vehicle_filters: 'Filtros de veículos',
    reset: 'Redefinir',
    transmission: 'Transmissão',
    all: 'Todos',
    manual: 'Manual',
    auto: 'Automático',
    passengers: 'Passageiros',
    vehicle_type: 'Tipo de veículo',
    filter: 'Filtrar',
    vehicle_search: 'Busca de veículo',
    edit: 'Editar',
    no_results: 'Nenhum resultado corresponde aos seus filtros.',
    small_cars: 'Carros pequenos',
    medium_cars: 'Carros médios',
    large_cars: 'Carros grandes',
    estate_cars: 'Peruas',
    suvs: 'SUVs',
    mpvs: 'MPVs',
    vans: 'Vans',
    camper_vans: 'Motorhomes',
    premium: 'Premium',
    unspecified: 'não especificado',
    large: 'grande',
    medium: 'médio',
    small: 'pequeno',
    automatic: 'automático',
    you_have_been_refunded: 'Você foi reembolsado.',
    please_customer_service: 'Para fazer uma reserva, entre em contato com nosso atendimento.',
    contact_customer_service: 'Contato com atendimento',
    booking_failed: 'Sua reserva não pôde ser processada desta vez.',
    summary: 'Resumo',
    reforestation_and_protection: 'Apoie o reflorestamento e a proteção da floresta tropical em toda a Costa Rica',
    cost_of_rental: 'Custo do aluguel',
    to_pay_now: 'A pagar agora',
    greenheart_donation: 'Doação Green Heart',
    total_cost: 'Custo total do aluguel',
    tc_agreement: 'Li e entendi os {0}.',
    tc: 'Termos e Condições',
    receive_offers: 'Gostaria de receber ofertas especiais por e-mail.',
    donate: 'Sim, gostaria de doar {amount}',
    pay_now: 'Pagar {amount} agora',
    driver_details: 'Dados do motorista',
    complete_driver_details: 'Por favor, complete os dados do motorista.',
    are_you_the_driver: 'Você é o motorista?',
    have_an_account: 'Já tem uma conta?',
    login: 'Entrar',
    or: 'ou',
    first_name: 'Nome do motorista',
    last_name: 'Sobrenome do motorista',
    email: 'E-mail',
    phone_number: 'Celular',
    unable_to_save_driver_information: 'Não foi possível salvar os dados do motorista. Tente novamente.',
    pay_online_now: 'Pagar agora',
    day: 'Dia',
    choose_location: 'Escolha um local',
    location_not_found: 'Desculpe, não encontramos o local solicitado.',
    add: 'Adicionar',
    remove: 'Remover',
    free_extra: 'Extra grátis',
    free: 'GRÁTIS!',
    fast_track_notice: 'Restrições de origem de documentos se aplicam a este serviço. Disponível apenas para pessoas com documentos de',
    complete_booking: 'Concluir reserva',
    choose_card: 'Escolha um cartão ou adicione um novo.',
    add_billing_details: 'Adicione os dados de faturamento.',
    card_number: 'Número do cartão',
    card_holder_name: 'Nome do titular',
    card_exp: 'MM / AA',
    card_cvc: 'CVC',
    save_card: 'Salvar cartão?',
    amount_charged: 'Seu cartão será cobrado',
    payment_confirmation: 'Confirmar reserva e pagar',
    payment_methods: 'métodos de pagamento disponíveis',
    use_saved_card: 'x usar cartão salvo',
    use_different_card: '+ usar outro cartão',
    book_now: 'Reservar agora',
    minimum_age: 'Apenas para maiores de {age}',
    excess_liability: 'Franquia',
    security_deposit: 'Depósito de segurança',
    fuel_policy: 'Política de combustível',
    like_for_like: 'Como recebido',
    full_to_full: 'Cheio para cheio',
    miles_per_rental: '{mileage} milhas grátis por aluguel',
    km_per_rental: '{mileage} km grátis por aluguel',
    unlimited_mileage: 'Quilometragem ilimitada',
    unlimited_mileage_km: 'Km ilimitados',
    non_amendable: 'Não alterável',
    non_refundable: 'Não reembolsável',
    free_cancellation_until: 'Cancelamento grátis até',
    cancellation_in_line_with: 'Cancelamento conforme',
    tcs: 'Termos e Condições',
    free_extras_on_collection: 'Dois extras grátis na retirada',
    glass_and_tyres_covered: 'Vidros e pneus cobertos',
    number_of_passengers: 'Número de passageiros',
    number_of_bags: 'Número de malas',
    fuel_type: 'Tipo de combustível',
    co2: 'CO2',
    book_type: 'Reservar {type}',
    processing: 'Processando',
    actual_price: 'Preço real',
    tooltip: 'O preço em {currencyCode} é uma estimativa baseada na cotação, o preço em {currency} é vinculativo.',
    deposit: 'Depósito',
    pay_online: 'Pagar agora',
    pay_online_without_extras: 'Preço do aluguel',
    extras_on_arrival: 'Extras na chegada',
    insurance_on_arrival: 'Redução de risco - pagar na chegada',
    insurance_online: 'Redução de risco - pagar agora',
    extras_online: 'Extras - pagar agora',
    green_heart_donation: 'Doação Green Heart',
    why_use_drive_and_go: 'Por que usar Drive & Go?',
    straight_to_car: 'Direto para o carro',
    no_queues: 'Sem filas',
    self_checkout: 'Autoatendimento',
    cant_lose_key: 'Não perde a chave',
    online_id_check: 'Verificação de ID online',
    phone_as_key: 'Telefone como chave',
    premiumplus_benefits_includes: 'Benefícios Premium Plus+ incluídos',
    book_drive_go: 'Reservar Drive & Go',
    distance_allowance: 'Limite de distância',
    duration: 'Duração',
    view_more_bookings: 'Ver mais reservas',
    to_pay_on_arrival: 'A pagar na chegada',
    pay_on_arrival: 'Pagar na chegada',
    unlimited: 'Ilimitado',
    return_date: 'Data de devolução',
    postcode: 'CEP',
    country: 'País',
    drive_and_go: {
        drive_and_go: 'Drive And Go',
        available_countries: 'Drive & Go está disponível apenas para pessoas com documentos de identidade e carteira de motorista dos seguintes países:',
        drive_and_go_today: 'Reserva Drive & Go para hoje!',
        drive_and_go_shortened: 'Drive & Go',
        why_use_drive_and_go: 'Por que usar Drive & Go?',
        straight_to_car: 'Direto para o carro',
        no_queues: 'Sem filas',
        self_checkout: 'Autoatendimento',
        cannot_lose_the_key: 'Não perde a chave',
        online_id_check: 'Verificação de ID online',
        phone_as_a_key: 'Telefone como chave',
        premium_plus_benefits_also_included: 'Benefícios Premium Plus+ incluídos',
        book_drive_and_go: 'Reservar Drive & Go',
    },
    car_and_camp: {
        tent_and_equipment: 'Tenda e equipamento',
        quick_and_easy: 'Rápida e fácil de montar',
        travel_freedom: 'Liberdade de viajar',
        affordable_campervan_alternative: 'Alternativa acessível à autocaravana',
        lightweight_and_compact: 'Leve e compacto',
        fully_insured: 'Totalmente segurado',
    },
    my_bookings: 'Minha reserva',
    no_bookings: 'Nenhuma reserva',
    my_profile: 'Meu perfil',
    no_bookings_to_display: 'Nenhuma reserva para exibir.',
    search_great_car_rental_deals: 'Encontre ótimas ofertas de aluguel de carros para sua próxima viagem.',
    odometer_at_collection: 'Odômetro na retirada',
    fuel_at_collection: 'Combustível na retirada',
    start_check_in: 'Iniciar check-in',
    start_collection: 'Iniciar retirada',
    recent_bookings: 'Reserva recente',
    damage: {
        updated_damage_report_submitted: 'Um relatório de danos atualizado foi enviado. Um membro da nossa equipe de atendimento entrará em contato se necessário.',
        add_additional_damage: 'Adicionar dano adicional',
        you_may_report_additional_damage_up_to: 'Você pode relatar danos adicionais até 24 horas após a retirada do veículo',
        specify_damage: 'Especificar dano',
        please_choose_the_area_and_type_of_damage: 'Escolha a área e o tipo de dano',
        type_of_damage: 'Tipo de dano',
        is_this_more_than_5_cm: 'Tem mais de 5 cm?',
        please_take_or_select_a_photo: 'Tire ou selecione uma foto',
        please_take_a_photo_ensuring_the_damage_is_clearly_visible: 'Tire uma foto garantindo que o dano esteja claramente visível',
        if_you_require_you_may_add_another_photo_select_the_icon_to_add_another_photo: ' Se necessário, adicione outra foto, selecione o ícone para adicionar',
        save_image: 'Salvar imagem',
        save_images: 'Salvar imagens',
        damage_saved_successfully: 'Dano salvo com sucesso',
        add_photo: 'Adicionar foto',
    },
    checkout: {
        start_collection: 'Iniciar retirada',
        collect_vehicle: 'Retirar veículo',
        we_will_let_you_know_the_details: 'Informaremos o local e detalhes para que você encontre o veículo alugado.',
        inspect: 'Inspecionar',
        we_will_ask_for_four_photos_from_each_corner: 'Solicitaremos quatro fotos de cada canto do veículo e de quaisquer novos danos não listados.',
        fuel_and_milage: 'Combustível & Quilometragem',
        you_confirm_the_readings_at_the_start_of_your_hire: 'Você confirma o odômetro e o combustível no início do aluguel.',
        sign: 'Assinar',
        sign_the_rental_agreement: 'Assine o contrato de aluguel.',
        away_you_go: 'Boa viagem',
        you_are_free_to_take_to_the_road: 'Você está pronto para pegar a estrada!',
        collect_your_vehicle: 'Retire seu veículo',
        get_directions: 'Obter direções',
        hide_directions: 'Ocultar direções',
        local_time: 'horário local',
        tel: 'Tel',
        getting_to_the_location: 'Como chegar ao local',
        get_vehicle_details: 'Ver detalhes do veículo',
        view_map: 'Ver mapa',
        unlock_vehicle_and_continue: 'Destravar veículo & continuar',
        unable_to_connect_to_vehicle: 'Não foi possível conectar ao veículo',
        we_were_unable_to_connect_to_the_vehicle_please_check: 'Não foi possível conectar ao veículo - verifique se está ao lado do veículo correto e tente novamente.',
        we_were_unable_to_find_the_vehicle_booking_please_try_again_later: 'Não foi possível encontrar a reserva do veículo. Tente novamente mais tarde.',
        odometer_and_fuel: 'Odômetro & combustível',
        odometer: 'Odômetro',
        please_confirm_the_odometer_and_fuel_readings: 'Se possível, confirme o odômetro e o combustível.',
        the_odometer_field_is_required: 'O campo odômetro é obrigatório',
        and_must_be_greater_than_the_checkout_odometer: '& deve ser maior que o odômetro da retirada',
        confirm: 'Confirmar',
        please_take_a_photo_from_each_corner_of_the_vehicle: 'Tire uma foto de cada canto do veículo',
        pre_existing_damage: 'Dano pré-existente',
        no_pre_existing_damage: 'Nenhum dano pré-existente.',
        new_damage: 'Novo dano',
        add_additional_damage: 'adicionar dano adicional',
        no_new_damage_to_report: 'Nenhum novo dano a relatar',
        checkout_complete: 'Retirada concluída',
        start_rental: 'Iniciar aluguel',
        congratulations_name_it_is_time_to_take_to_the_road: 'Parabéns {customer_name}, é hora de pegar a estrada!',
        we_are_unable_to_complete_your_vehicle_checkout: 'Não foi possível concluir a retirada do veículo.',
        please_do_the_following: 'Por favor, faça o seguinte',
        remove_all_belonging_and_lock_the_vehicle: 'Retire todos os pertences e tranque o veículo.',
        lock_vehicle: 'Trancar veículo',
        once_you_have_contacted_customer_services: 'Após contatar o atendimento',
        vehicle_location: 'Local do veículo',
        collect_your: 'Retire seu',
        from: 'De',
        key_in_glove_box: 'sua chave está no porta-luvas',

        keyholder: {
            not_detected: 'Chave não detectada no porta-chaves',
            not_detected_please_try_again: 'Coloque sua chave no porta-chaves e tente novamente.',

            not_installed: 'Porta-chaves não instalado',
            not_installed_please_contact_customer_service: 'Porta-chaves não instalado, entre em contato com o atendimento.',
        },
        keyring: {
            look_up_failed: 'Porta-chaves não encontrado',
            look_up_failed_please_contact_customer_service: 'Porta-chaves não encontrado, entre em contato com o atendimento.',
        },
        key: {
            invalid: 'Chave inválida',
            invalid_please_contact_customer_service: 'Sua chave é inválida, entre em contato com o atendimento.',

            expired: 'Chave expirada',
            expired__please_contact_customer_service: 'Sua chave expirou, entre em contato com o atendimento.',
        },
    },
    checkin: {
        start_check_in: 'Iniciar check-in',
        vehicle_location: 'Local do veículo',
        tell_us_where_you_have_parked: 'Diga-nos onde estacionou o veículo.',
        fuel_and_milage: 'Combustível & Quilometragem',
        you_confirm_the_readings_at_the_end_of_your_hire: 'Você confirma o odômetro e o combustível no final do aluguel.',
        inspect: 'Inspecionar',
        we_will_as_for_four_photos_from_each_corner_of_the_vehicle_along_with_any_new_damage: 'Solicitaremos quatro fotos de cada canto do veículo e de quaisquer novos danos durante o aluguel.',
        lock: 'Trancar',
        check_you_have_left_no_belonging_then_lock_the_vehicle: 'Verifique se não deixou pertences e tranque o veículo.',
        please_tell_us_where_you_have_parked_the_vehicle: 'Diga-nos onde estacionou o veículo',
        once_the_vehicle_is_locked_you_will_be_unable_to_unlock_it_again: 'Após trancar o veículo, não será possível destrancá-lo novamente.',
        name_please_check_you_have_left_no_belongings_then_lock_the_vehicle:
            '{first_name}, verifique se não deixou pertences, tranque o veículo e, se necessário, devolva a chave física ao porta-chaves.',
        lock_vehicle: 'Trancar veículo',
        complete_check_in: 'Concluir check-in',
        inspection: 'Inspeção',
        complete_vehicle_check_in: 'Concluir check-in do veículo',
        we_are_unable_to_complete_your_vehicle_check_in: 'Não foi possível concluir o check-in do veículo.',
        please_contact_customer_services: 'Entre em contato com o atendimento',
        once_you_have_contacted_customer_services: 'Após contatar o atendimento',
        please_amend_odometer_to_be_greater_than: 'Altere o odômetro para ser maior que {odometer_value}',
    },
    rental_agreement: {
        rental_agreement: 'Contrato de aluguel',
        agreement_between: 'Contrato entre',
        and: 'e',
        sign_rental_agreement: 'Assinar contrato de aluguel',
        i_have_read_and_understood_the_terms_and_conditions: 'Li e entendi os Termos e Condições e aceito o estado do veículo',
    },
    additional_options: 'Opções adicionais',
    booking_details: 'Detalhes da reserva',
    price_for_x_days: 'Preço para {qty_of_days} dia | Preço para {qty_of_days} dias',
    cancelled: 'Cancelado',
    upcoming: 'Próximo',
    active: 'Ativo',
    full_insurance_no_deposit: 'Seguro total & sem necessidade de depósito',
    excess: '{amount} franquia',
    deposit: '{amount} depósito',
    included_daily_distance: '{distance} {unit} por dia',
    miles: 'milhas',
    kilometers: 'quilômetros',
    collection_details_title: 'Detalhes da retirada',
    collection_details_not_found: 'Nenhum detalhe de retirada definido para este local',
    free_cancellation: 'Cancelamento grátis',
    no_deposit: 'Sem depósito',
    benefit_from: 'Aproveite',
    for_only_per_day: 'Por apenas {price} por dia',
    upgrade_mee: 'UpgradeMee',
};
